import { Button } from '@design-system/components/button/button';

type ChannelLandingPageHeaderButtonProps = {
  onClick: () => void;
};

export const ChannelLandingPageHeaderButton = ({
  onClick,
}: ChannelLandingPageHeaderButtonProps) => (
  <Button
    color="primaryTonal"
    onClick={onClick}
    testId="programs-header-channel-landing-link"
  >
    Channel landing page
  </Button>
);
